<p-confirmDialog key="roomadd" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="MainGrid2Col">
	<label>Room No:</label>
	<input
		[disabled]="IsLoading() == true"
		type="text"
		class="form-control"
		style="min-width: 250px"
		[(ngModel)]="RoomNo"
		maxlength="10"
		placeholder="10 Character Room Code/Number"
	/>

	<label>Description:</label>
	<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="RoomDesc" maxLength="50" placeholder="Room Description" />

	<label>School:</label>
	<label class="InfoText">{{ SchoolName }}</label>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button [disabled]="Processing == true" class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>
